import React, { useState } from "react";
import TextInputField from "../../../utils/Fields/TextInputField";
import { useDropzone } from "react-dropzone";
import { FooterButton } from "../Components/curatorApprovalStyle";
import ImageList from "../../Administration/Screens/LandingPageHero.js/ImageList";
import {
  Box,
  Typography,
  useMediaQuery,
  TextField,
  InputAdornment,
} from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";

import useThemeRender from "../../../theme/useThemeRender";
import { getImagePreview } from "../../../utils/function";
import DropZone from "../../../utils/Upload/Dropzone";
import { useSelector } from "react-redux";
import FileView from "../../Administration/FileView/FileView";

const YearlyArtifactDocumentComponent = ({
  register,
  artifactManagementArray,
  onSave,
  showAddMoreArtificats,
  contentType,
}) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isDarkTheme = useSelector((state) => state.theme);
  const [isDocumentDropped, setIsDocumentDropped] = useState(false);
  const [isThumbnailDropped, setIsThumbnailDropped] = useState(false);
  const [selectedDocumentImage, setSelectedDocumentImage] = useState(null);
  const [selectedThumbnailImage, setSelectedThumbnailImage] = useState(null);
  const [documentFile, setDocumentFile] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  const disabled =
    ((contentType === "LINK" || !selectedDocumentImage) &&
      !documentFile?.fileUrl?.trim()) ||
    !selectedThumbnailImage;

  const getArticatesVersionNumber = () => {
    return Math.round(artifactManagementArray?.[0].versionNumber) + 1;
  };

  const onDropDocument = (acceptedFiles) => {
    console.log(acceptedFiles);
    const newImage = acceptedFiles[0];
    let imageWithPreview = getImagePreview(newImage);
    const updatedImage = [imageWithPreview];
    setDocumentFile(newImage);
    setSelectedDocumentImage(updatedImage);
    setIsDocumentDropped(true);
  };

  const onDropThumb = (acceptedFiles) => {
    const newImage = acceptedFiles[0];
    const imageWithPreview = Object.assign(newImage, {
      preview: URL.createObjectURL(newImage),
    });
    const updatedImage = [imageWithPreview];
    setImageFile(newImage);
    setSelectedThumbnailImage(updatedImage);
    setIsThumbnailDropped(true);
  };

  const { getRootProps, getInputProps } = useDropzone({
    ...(contentType === "VIDEO"
      ? {
          accept: { "video/*": [] },
        }
      : {}),
    onDrop: onDropDocument,
    maxFiles: 1,
  });

  const { getRootProps: getRootPropsThumb, getInputProps: getInputPropsThumb } =
    useDropzone({
      accept: { "image/*": [] },
      onDrop: onDropThumb,
      maxFiles: 1,
    });

  const handleDeleteDocument = async () => {
    setDocumentFile(null);
    setSelectedDocumentImage(null);
    setIsDocumentDropped(false);
  };
  const handleDeleteThumb = async (docType) => {
    setImageFile(null);
    setSelectedThumbnailImage(null);
    setIsThumbnailDropped(false);
  };

  return (
    <Box
      sx={{
        background: useThemeRender("cardBackgroundColorLayer2"),
      }}
    >
      <>
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: "16px",
            padding: "16px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              width: { sm: "100%", md: "360px" },
            }}
          >
            {contentType === "LINK" ? (
              <>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 400,
                    mt: 1,
                    mb: 0.5,
                    fontFamily: "var(--Typography-Font-Family-Body, Inter)",
                  }}
                >
                  Link
                </Typography>
                <TextField
                  placeholder="Paste Link"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-input": {
                      padding: "0px 8px",
                      lineHeight: "20px",
                      fontSize: "14px",
                      height: "32px",
                    },
                  }}
                  value={documentFile?.fileUrl ?? ""}
                  onChange={(e) => setDocumentFile({ fileUrl: e.target.value })}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">
                          <LinkIcon sx={{ fontSize: "16px" }} />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </>
            ) : (
              <Box
                sx={{
                  width: "408px",
                  maxWidth: "100%",
                  height: isDocumentDropped ? "auto" : "186px",
                  top: "16px",
                  left: "16px",
                  gap: "18px",
                  borderRadius: " var(--Cornerradiuseffect-corner-2)",
                }}
              >
                {isDocumentDropped ? (
                  <FileView
                    fileDocument={documentFile}
                    onDelete={handleDeleteDocument}
                    onPreview={() => {}}
                  />
                ) : (
                  <DropZone
                    getRootProps={getRootProps}
                    getInputProps={getInputProps}
                    isDarkTheme={isDarkTheme}
                    label="Document"
                    uploadImageLabel="Upload File"
                    isRequired
                  />
                )}
              </Box>
            )}
            <Box
              sx={{
                width: "408px",
                maxWidth: "100%",
                height: "186px",
                top: "16px",
                left: "16px",
                paddingTop: "42px",
                borderRadius: " var(--Cornerradiuseffect-corner-2)",
              }}
            >
              {isThumbnailDropped ? (
                <ImageList
                  images={[...selectedThumbnailImage]}
                  onDelete={handleDeleteThumb}
                  onReplace={(file) => onDropThumb([file])}
                />
              ) : (
                <DropZone
                  getRootProps={getRootPropsThumb}
                  getInputProps={getInputPropsThumb}
                  isDarkTheme={isDarkTheme}
                  label="Thumbnail"
                  informativeText="Drag and drop your file here (only .jpg,.png)"
                  uploadImageLabel="Upload Image"
                  isRequired
                />
              )}
            </Box>
            <Box
              sx={{
                paddingTop: "42px",
              }}
            >
              <TextInputField
                label="Version Number"
                type="number"
                errors={false}
                register={register}
                name="newVersionNumber"
                value={getArticatesVersionNumber()}
                width={!isMobile ? 250 : "100%"}
              />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            height: "32px",
            padding: "0px 16px 0px 16px",
            gap: "12px",
            marginBottom: "12px",
            justifyContent: isMobile ? "space-between" : "end",
          }}
        >
          <FooterButton
            sx={{
              background: "",
              color: "#005CBC",
              border: "1px solid var(--Tokens-Button-Outlined, #005CBC)",
              flex: isMobile && 1,
            }}
            onClick={() => showAddMoreArtificats(false)}
          >
            Cancel
          </FooterButton>
          <FooterButton
            sx={{
              background: disabled ? "#A0A0A0" : "#005CBC",
              flex: isMobile && 1,
            }}
            disabled={disabled}
            onClick={() =>
              onSave([[documentFile], [imageFile]], getArticatesVersionNumber())
            }
          >
            Save
          </FooterButton>
        </Box>
      </>
    </Box>
  );
};

export default YearlyArtifactDocumentComponent;
